import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const uploadApi = createApi({
  reducerPath: 'uploadApi',
  baseQuery: createBaseQuery('uploads', { timeout: 0 }),
  endpoints: builder => ({
    getUploads: builder.query({
      query: params => `?${toQueryParams(params)}`,
      transformResponse: ({ result }) => result,
    }),
    getUpload: builder.query({
      query: id => `/${id}`,
      transformResponse: ({ result }) => result,
    }),
    signUpload: builder.query({
      query: params => `/sign?${toQueryParams(params)}`,
      transformResponse: ({ result }) => result,
    }),
    createUpload: builder.mutation({
      query: params => ({
        url: '/',
        method: 'POST',
        body: params,
      }),
      transformResponse: ({ result }) => result,
    }),
    updateUpload: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: 'PUT',
        body,
      }),
      transformResponse: ({ result }) => result,
    }),
    deleteUpload: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const {
  useGetUploadsQuery,
  useGetUploadQuery,
  useLazyGetUploadQuery,
  useLazySignUploadQuery,
  useCreateUploadMutation,
  useUpdateUploadMutation,
  useDeleteUploadMutation,
} = uploadApi;
